module.exports = __webpack_public_path__ + "img/buffalorock-logo.cceea744.jpg";